import {Box, Button, Typography} from '@mui/material';
import {useNavigate, useSearchParams} from 'react-router';

export default function SubscriptionError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorMessage = searchParams.get('message') || 'An error occurred during the subscription process';

  return (
    <Box sx={{p: 3, textAlign: 'center'}}>
      <Typography variant="h4" gutterBottom color="error">
        Subscription Error
      </Typography>
      <Typography variant="body1" gutterBottom>
        {errorMessage}
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/subscription')} sx={{mt: 2}}>
        Return to Subscription Page
      </Button>
    </Box>
  );
}
